import { graphQuery, graphMutation } from './commService';

export const fetchSpeechTopics = async () => {
  const query = `
  query {
    speechStimuli {
      id
      type
      locale
      text
      population
      }
      }
      `;
  const res = await graphQuery(query, true);
  return res?.data?.speechStimuli || [];
};

export const bulkCreateSpeechTopics = async (inputs) => {
  const mutation = `
        mutation($inputs: [SpeechStimuliInput!]!) {
          bulkCreateSpeechStimuli(inputs: $inputs) {
            id
            type
            locale
            text
            population
          }
        }
      `;
  const res = await graphMutation(mutation, { inputs }, true);
  return res?.data?.bulkCreateSpeechStimuli || [];
};

export const deleteSpeechTopic = async (id) => {
  const mutation = `
    mutation($id: String!) {
      deleteSpeechStimulus(id: $id)
    }
  `;
  const res = await graphMutation(mutation, { id }, true);
  return res?.data?.deleteSpeechStimulus;
};

export const updateSpeechTopic = async (id, input) => {
  const mutation = `
    mutation($id: String!, $input: UpdateSpeechStimulusInput!) {
      updateSpeechStimulus(id: $id, input: $input) {
        id
        type
        locale
        text
        population
      }
    }
  `;
  const res = await graphMutation(mutation, { id, input }, true);
  return res?.data?.updateSpeechStimulus || null;
};
